<button (click)="openModal()" class="{{ andClass }}">
  {{ label ? label : ('feedback_button.label_long_text' | translate) }}
</button>
